import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/home.vue';
import HomeWebView from '../views/homeweb.vue';
import MeView from '../views/me.vue';
import LoginView from '../views/Login.vue';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true }
  },
  {
    path: '/web',
    name: 'web',
    component: HomeWebView,
    meta: { requiresAuth: true }
  },
  {
    path: '/me',
    name: 'me',
    component: MeView,
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

// 路由守卫
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('token'); // 检查是否已登录
  
  if (to.meta.requiresAuth && !isAuthenticated) {
    // 需要登录但未登录，重定向到登录页
    next('/login');
  } else if (to.path === '/login' && isAuthenticated) {
    // 已登录但访问登录页，重定向到首页
    next('/');
  } else {
    next();
  }
});

export default router; 